module.exports = __webpack_public_path__ + "img/panele3.e3519e52.jpg";